import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

import LogoImg from '../../assets/logo.png'; 

const Header = () => (
	 <header className="Header__SiteHeader-sc-1ffv7i6-0 dItzqG sticky-header  ">
	 <div className="container-fluid">
			<nav className="navbar px-0 px-md-3 site-navbar offcanvas-active navbar-expand-lg navbar-light">
				<div className="brand-logo">
					<a aria-current="page" className="" href="/">
						<img 
                            src={LogoImg} 
                            alt="PurpleBin Company Logo" 
                            // Added simple inline style for initial sizing. Adjust the height as needed.
                            style={{ height: '100px', maxWidth: '100%', display: 'block' }} 
                        />
					</a>
				</div>
				<div className="collapse navbar-collapse">
					<div className="navbar-nav ml-lg-auto mr-3">
						<nav>
							<ul className="Header__Menu-sc-1ffv7i6-2 fnluip navbar-nav d-none d-lg-flex">
								{/* <li className="nav-item"><a className="nav-link" href="https://www.fxhash.xyz/u/PurplebinDAO" target="_blank" rel="noreferrer">Mint</a></li> */}
								{/* <li className="nav-item"><a className="nav-link" href="/#">contact</a></li>
								<li className="nav-item"><a className="nav-link" href="https://uxtheme.net/theme-support" target="_blank" rel="noreferrer">support</a></li> */}
								<li className="nav-item"><a className="nav-link" href="https://x.com/PurplebinLLC" target="_blank" rel="noreferrer">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
										<path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
									</svg>
								</a></li>

							
							</ul>
						</nav>
					</div>
				</div>
				<button
					className="Header__ToggleButton-sc-1ffv7i6-1 bLVlJJ navbar-toggler btn-close-off-canvas ml-3 "
					type="button"
					data-toggle="collapse"
					data-target="#mobile-menu"
					aria-controls="mobile-menu"
					aria-expanded="false"
					aria-label="Toggle navigation"
				>
					<i className="icon icon-menu-34 icon-burger d-block" />
				</button>
			</nav>
	 </div>
	</header>
);

export default Header;
